import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { I18nProvider } from './i18n/index.jsx';
import { AuthProvider } from './auth.jsx';
import { ChatProvider } from './chat/ChatProvider.jsx';
import { LiveProvider } from './live.jsx';
import App from './App.jsx';
import { TutorialsProvider } from './tutorials/TutorialSlot.jsx';
import ErrorBoundary from './components/ErrorBoundary.jsx';
import './styles/app.css';

createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <BrowserRouter>
      <I18nProvider>
        <ErrorBoundary>
          <AuthProvider>
            <ChatProvider>
              <LiveProvider>
                <TutorialsProvider>
                  <App />
                </TutorialsProvider>
              </LiveProvider>
            </ChatProvider>
          </AuthProvider>
        </ErrorBoundary>
      </I18nProvider>
    </BrowserRouter>
  </React.StrictMode>
);
